import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/solutions/axle-load-monitoring/page.tsx");
